import React from "react";

/**
 * The app's `SponsoredBadge`: a white "Sponsored" pill with the green tag icon
 * (`assets/icon/sponsored.svg`, 12 px, 4 px gap) on the photo of a paid-boosted
 * (Featured Stays) card, wherever one shows.
 */
const SponsoredBadge: React.FC = () => (
  <span className="inline-flex items-center gap-1 rounded-full bg-white px-3 py-1.5 text-xs font-semibold leading-none text-ink-black shadow-[0_1px_2px_rgba(0,0,0,0.08)]">
    <img src="/icons/boost/sponsored.svg" alt="" className="h-3 w-3" />
    Sponsored
  </span>
);

export default SponsoredBadge;
